// フッターの著作権表記の年を、閲覧時点の年に自動更新する
export const initCopyrightYear = () => {
  const year = new Date().getFullYear();
  document.querySelectorAll('.js-copyright-year').forEach((el) => {
    el.textContent = year;
  });
};
